import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "delete-account",
    templateUrl: "./delete-account.component.html",
    styleUrls: ["./delete-account.component.scss"]
})

export class DeleteAccountComponent {
    @Input() request: any;
    @Output() submitData = new EventEmitter();
    public form: FormGroup;
    public types = [
        {
            id: 1,
            type: this.translateService.instant("pt.edp.edponline.request_operations.delete_request.bullet.one"),
            selected: false
        },
        {
            id: 2,
            type: this.translateService.instant("pt.edp.edponline.request_operations.delete_request.bullet.two"),
            selected: false
        },
    ];

    constructor(
        private fb: FormBuilder,
        private store: Store<IAppState>,
        private translateService: TranslateService
    ) {
        this.form = this.fb.group({
            type: new FormControl(null, Validators.required)
        });

        this.form.valueChanges.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(() => {
            this.submitData.emit(!!this.form.valid ? this.form.value : null);
        });
    }

    public setTypeDelete(id, type) {
        this.types.map(el => { el.selected = el.id === id ? !el.selected : false; });

        this.form.get("type").setValue(!!this.types.find(el => el.selected) ? type : null);
    }

}
